import {useEffect, useState} from 'react';
import classNames from 'classnames';

import SocialButton from '../socialButtons/socialButton';
import {system} from 'services/objects';
import {LogoSvg} from 'components/Icons';
import LoginLink from './loginLink';
import LoginButton from './loginButton';
import HOCPageSwitcher from './HOCPageSwitcher';
import FormComponent from './FormComponent';

import styles from '../styles.module.scss';

function getKeyByValue(object, value) {
  return Object.keys(object).filter(key => object[key] === value);
}

const loginLogo = <LogoSvg classes={'top-bar-icon'} height={'5em'} width={'5.2em'} color={'white'} />;

const {
  CONFIG_PARAMS: {REGISTRATION_TYPE, AUTH_TYPE},
  PAGES: {REGISTRATION},
} = system;

function getSocialButtons(visibleLinks) {
  /**
   * styles for socialButtons
   * @type {string}
   */

  const socialClasses = classNames(styles.socialContainerLink, styles.linkStyles);
  return visibleLinks.map(linkName => (
    <SocialButton key={linkName} fontawesome={linkName} socialClasses={socialClasses} />
  ));
}

const PageTemplate = ({
  loginPage,
  activeContainer,
  additionalContainer,
  fields,
  rightPanelActiveToggle,
  activePage,
}) => {
  const [socialsReg, setSocialsReg] = useState([]);
  const [socialsAuth, setSocialsAuth] = useState([]);
  /**
   * show visible types/links of Authorisation
   * */
  useEffect(() => {
    const visibleLinks = getKeyByValue(loginPage[AUTH_TYPE], true);
    if (visibleLinks.length) {
      const links = getSocialButtons(visibleLinks);
      setSocialsAuth(links);
    }
  }, [loginPage[AUTH_TYPE]]);

  /**
   * show visible types/links of Registration
   * */
  useEffect(() => {
    const visibleLinks = getKeyByValue(loginPage[REGISTRATION_TYPE], true);
    if (visibleLinks.length) {
      const links = getSocialButtons(visibleLinks);
      setSocialsReg(links);
    }
  }, [loginPage[REGISTRATION_TYPE]]);

  const showLinks = containerType => {
    if (Boolean(containerType.links.length)) {
      return containerType.links.map(linkData => <LoginLink key={linkData.key} link={linkData} />);
    }
  };
  const showButtons = containerType => {
    if (Boolean(containerType.buttons.length)) {
      return containerType.buttons.map(buttonData => <LoginButton key={buttonData.key} button={buttonData} />);
    }
  };

  const registrationType = activePage === REGISTRATION ? loginPage[REGISTRATION_TYPE] : loginPage[AUTH_TYPE];

  const socialsLinks = activePage === REGISTRATION ? socialsReg : socialsAuth;

  return (
    <div className={classNames(styles.container)}>
      {/*Active container with form and fields*/}
      <FormComponent
        additionalClasses={activeContainer.classes}
        classContainer={rightPanelActiveToggle ? styles.signUpContainer : styles.signInContainer}
        classContainerActive={rightPanelActiveToggle ? styles.signUpContainerActive : styles.signInContainerActive}
        rightPanelActiveToggle={rightPanelActiveToggle}
        activeContainer={activeContainer}
        registrationType={registrationType}
        socialsLinks={socialsLinks}
        fields={fields}
        showLinks={showLinks}
        showButtons={showButtons}
      />

      {/*Additional container*/}
      <div
        className={classNames(
          styles.overlayContainer,
          `${rightPanelActiveToggle ? styles.overlayContainerActive : ''}`
        )}
      >
        <div className={classNames(styles.overlay, `${rightPanelActiveToggle ? styles.overlayActive : ''}`)}>
          <div
            className={classNames(
              styles.overlayPanel,
              `${rightPanelActiveToggle ? styles.overlayRightActive : styles.overlayLeftActive}`
            )}
          >
            {loginLogo}
            <h1 className={styles.headingText}>{additionalContainer.title}</h1>
            <p className={styles.secondaryText}>{additionalContainer.text}</p>
            {showButtons(additionalContainer)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HOCPageSwitcher(PageTemplate);
